import styled from "styled-components";

export const Fieldset = styled.fieldset`
  border: none;

  display: flex;
  flex-direction: column;

  label {
    color: #f8f9fa;
    font-weight: 400;
    font-size: 12.182px;

    padding-bottom: 10px;
  }

  input {
    width: 100%;
    height: 48px;

    background: #343b41;

    border: 1.2182px solid #f8f9fa;
    border-radius: 4px;

    padding-left: 20px;
    margin-bottom: 10px;
    
  }

`;
